import { render, staticRenderFns } from "./FrequentlyBoughtBrick.vue?vue&type=template&id=2b8277f2&"
import script from "./FrequentlyBoughtBrick.vue?vue&type=script&lang=js&"
export * from "./FrequentlyBoughtBrick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports